import Circuit from 'src/models/circuit/Circuit'
import Model, { encoders, ID, IsoDateTime } from 'src/models/model'
import User from 'src/models/user/User'

export default class AccountManager extends Model {
  static name = 'AccountManager'

  static deletable = true

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      circuit: {
        type: Circuit,
        output: true,
        reference: true
      },
      user: {
        type: User,
        required: true,
        encode: encoders.hasOne
      },
      hidePhone: {
        type: Boolean,
        required: true
      },
      createdAt: {
        type: IsoDateTime,
        output: true,
        sortable: true
      }
    }
  }
}
